<template>
	<v-dialog
		v-model="showDialog"
		max-width="700"
		@click:outside="showDialog = false"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">注文データ詳細</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-toolbar-title style="color: white" @click="showDialog = false"
					><v-icon>mdi-close</v-icon></v-toolbar-title
				>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-2">
				<v-row no-gutters justify="end">
					<v-btn
						v-if="authority_flag"
						class="ml-auto mr-2"
						color="secondary"
						dense
						@click="openEditPage()"
					>
						<v-icon class="mr-2">mdi-pencil</v-icon>
						内容を変更する</v-btn
					>
				</v-row>

				<v-sheet elevation="0" class="mt-4">
					<h3 class="component-index">注文先情報</h3>
					<table width="100%" class="show-dialog-table mt-2">
						<tbody>
							<tr>
								<th width="30%" class="font-weight-bold">注文番号</th>
								<td width="70%">{{ order_data.order_number }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">注文日</th>
								<td width="70%">{{ order_data.order_date | dateFormatter }}</td>
							</tr>
							<tr v-if="order_data.supplier">
								<th width="30%" class="font-weight-bold">発注先</th>
								<td width="70%">{{ order_data.supplier.name }}</td>
							</tr>
							<tr v-if="order_data.supplier">
								<th width="30%" class="font-weight-bold">発注先担当者</th>
								<td width="70%">{{ order_data.supplier.pic_name }}</td>
							</tr>
							<tr v-if="order_data.supplier">
								<th width="30%" class="font-weight-bold">発注先メールアドレス</th>
								<td width="70%">{{ order_data.supplier.email }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">注文状況</th>
								<td width="70%">
									{{ order_data.status_type_i18n }}
								</td>
							</tr>
						</tbody>
					</table>
					<div
						v-for="(order_data_component, index) in order_data_components"
						:key="order_data_component.id"
					>
						<h3 class="component-index">
							{{ `注文部品 #${index + 1}` }}
						</h3>
						<table width="100%" class="show-dialog-table mt-1">
							<tbody>
								<tr>
									<th width="30%" class="font-weight-bold">部品名</th>
									<td width="70%">{{ order_data_component.component_name }}</td>
								</tr>
								<tr
									v-if="
										order_data_component &&
										order_data_component.order_component &&
										order_data_component.order_component.ordered_product
									"
								>
									<th width="30%" class="font-weight-bold">対象製造番号</th>
									<td width="70%">
										{{ order_data_component.order_component.ordered_product.product_number }}
									</td>
								</tr>
								<tr v-else>
									<th width="30%" class="font-weight-bold">対象製造番号</th>
									<td width="70%">対象製造番号はありません</td>
								</tr>
								<tr
									v-if="
										order_data_component &&
										order_data_component.order_component &&
										order_data_component.order_component.ordered_product
									"
								>
									<th width="30%" class="font-weight-bold">対象製品名</th>
									<td width="70%">
										{{ order_data_component.order_component.ordered_product.product.name }}
									</td>
								</tr>
								<tr
									v-else-if="
										order_data_component &&
										order_data_component.order_component &&
										order_data_component.order_component.matter_product
									"
								>
									<th width="30%" class="font-weight-bold">対象製品名</th>
									<td width="70%">
										{{ order_data_component.order_component.matter_product.product.name }}
									</td>
								</tr>
								<tr v-else>
									<th width="30%" class="font-weight-bold">対象製品名</th>
									<td width="70%">対象製品はありません</td>
								</tr>

								<tr>
									<th width="30%" class="font-weight-bold">発注単価</th>
									<td width="70%" v-if="order_data_component.unit_price">
										{{ order_data_component.unit_price | formatPrice }}円
									</td>
									<td width="70%" v-else></td>
								</tr>
								<tr>
									<th width="30%" class="font-weight-bold">発注個数</th>
									<td width="70%">{{ order_data_component.quantity }}</td>
								</tr>
								<tr>
									<th width="30%" class="font-weight-bold">仕様</th>
									<td width="70%">{{ order_data_component.remarks }}</td>
								</tr>
								<tr>
									<th width="30%" class="font-weight-bold">納期</th>
									<td width="70%">
										{{ order_data_component.expected_receiving_date | dateFormatter }}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<v-btn
						class="mt-3"
						color="secondary"
						dense
						dark
						outlined
						@click="openPurchaseOrderPage()"
						v-if="order_data.status_type === 'sent'"
					>
						注文書</v-btn
					>
					<h3 class="component-index">送信メール情報</h3>
					<table
						v-if="order_data.mail_infos && order_data.mail_infos.length"
						width="100%"
						class="show-dialog-table"
					>
						<tbody>
							<tr>
								<th width="30%" class="font-weight-bold">送信日時</th>
								<td
									width="70%"
									v-if="order_data && order_data.mail_infos && order_data.mail_infos.length"
								>
									{{ order_data.mail_infos[0].created_at | dateFormatter }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">送信者</th>
								<td
									width="70%"
									v-if="order_data && order_data.mail_infos && order_data.mail_infos.length"
								>
									{{ order_data.mail_infos[0].user.full_name }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">送信タイトル</th>
								<td
									width="70%"
									v-if="order_data && order_data.mail_infos && order_data.mail_infos.length"
								>
									{{ order_data.mail_infos[0].title }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">送信内容</th>
								<td width="70%">
									<p class="mail-content" v-html="mailContent"></p>
								</td>
							</tr>
						</tbody>
					</table>

					<div v-else class="mt-2">
						<p>送信メールはありません</p>
					</div>
					<div
						v-for="(file, index) in order_data.return_all_attached_file_infos"
						:key="`file-${file.id}`"
					>
						<h3 v-if="!file.destroy_flag" class="component-index">
							{{ `添付ファイル #${index + 1}` }}
						</h3>
						<v-btn v-if="!file.destroy_flag" class="mt-2" :href="file.url">{{ file.name }}</v-btn
						><v-icon
							v-if="!file.destroy_flag && order_data.status_type == 'draft'"
							class="mt-2"
							@click="openConfirmationDialog(file.id)"
							>mdi-delete</v-icon
						>
					</div>
				</v-sheet>
			</v-sheet>
		</v-card>
		<OrderDataConfirmationDialog
			:dialog.sync="deleteDialog"
			:dialogTitle="dialogTitle"
			:dialogContent="dialogContent"
			:fileDeleteFlag="fileDeleteFlag"
			@deleteFile="deleteFile"
		/>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import moment from "moment"
import "moment/locale/ja"
import OrderDataConfirmationDialog from "./OrderDataConfirmationDialog.vue"

export default {
	components: {
		OrderDataConfirmationDialog,
	},
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},

		order_data_id: {
			type: null,
			required: false,
		},
	},
	data() {
		return {
			order_data: {},
			order_data_components: [],
			authority_flag: false,
			file_id: "",
			dialogTitle: "",
			dialogContent: "",
			fileDeleteFlag: false,
			deleteDialog: false,
		}
	},
	filters: {
		dateFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("YYYY年MM月DD日(dd)")
		},
		datetimeFormatter(date) {
			if (date) {
				return moment(date).format("YYYY/MM/DD HH:mm")
			}
		},
		formatPrice(price) {
			if (price != null) {
				return price.toLocaleString()
			}
		},
	},

	methods: {
		fetchOrderData(order_data_id) {
			const headers = authenticate.setHeader()

			axios
				.get(`/erp/v1/order_data/order_data/${order_data_id}`, {
					headers,
				})
				.then((res) => {
					this.order_data = res.data.order_data

					this.order_data_components = res.data.order_data.order_data_components
					this.authority_flag = res.data.authority_flag
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},

		openEditPage() {
			this.$router.push({
				path: `/order_data/${this.order_data_id}/edit`,
				query: {
					order_data_id: this.order_data_id,
				},
			})
		},
		translateStatus(status) {
			return this.statusSituation[status]
		},
		replaceUrlWithLink(url) {
			return `<a href="${url}" target="_blank">${url}</a>`
		},
		deleteFile() {
			const headers = authenticate.setHeader()

			axios
				.delete(`/erp/v1/order_data/files/${this.file_id}`, {
					headers,
				})
				.then((res) => {
					this.order_data.return_all_attached_file_infos = res.data.return_all_attached_file_infos
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		openPurchaseOrderPage() {
			this.$router.push({ name: "order_data_purchase_order", params: { id: this.order_data_id } })
		},
		openConfirmationDialog(file_id) {
			this.file_id = file_id
			this.dialogTitle = "添付ファイル削除"
			this.dialogContent = "添付ファイルを削除しますか？"
			this.fileDeleteFlag = true
			this.deleteDialog = true
		},
	},

	computed: {
		mailContent() {
			if (this.order_data && this.order_data.mail_infos && this.order_data.mail_infos.length) {
				const urlPattern = /((http|https):\/\/[^\s]+)/g
				const linkedContent = this.order_data.mail_infos[0].content.replace(
					urlPattern,
					this.replaceUrlWithLink
				)
				return linkedContent
			}
		},
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
	watch: {
		order_data_id(newVal, oldVal) {
			if (newVal == oldVal) return
			this.fetchOrderData(newVal)
		},
	},
}
</script>

<style scoped lang="scss">
@import "../../../stylesheet/variable.scss";
.component-index {
	font-weight: bold;
	margin-top: 20px;
}
p.mail-content {
	word-break: break-all;
	white-space: pre-line;
}
</style>
